const de = {
  common: {
    loading: "Wird geladen...",
    please_wait: "Bitte warten",
    kent_project: "Ein Produkt des KenT-Projekts"
  },
  nav: {
    home: "Startseite",
    gallery: "Galerie",
    guide: "Anleitung",
    create_frames: "Rahmen erstellen",
    how_to_use: "Bedienungsanleitung",
    about: "Über uns",
    contact: "Kontakt"
  },
  home: {
    welcome_to: "Willkommen bei",
    subtitle: "Mache Fotos online mit Hunderten angesagter Rahmen für 2026. Keine App, kein Wasserzeichen und privater Schutz — aufnehmen und sofort teilen!",
    start_capture: "FOTOSHOOTING STARTEN",
    view_gallery: "GALERIE ANSEHEN",
    follow_social: "Folge KenT Photobooth auf Facebook und TikTok",
    social_popup_title: "Folge uns!",
    social_popup_desc: "Verbinde dich mit KenT Photobooth auf Facebook und TikTok, um die neuesten Updates und Rahmen zu erhalten.",
    explore_now: "Jetzt erkunden",
    memory_corner: "Erinnerungsecke",
    how_to_shoot: "Wie macht man Fotobox-Bilder?",
    card1_title: "Wähle einen Rahmen",
    card1_desc: "Wähle einen Rahmen aus, klicke auf 'Weiter' und starte das Shooting!",
    card2_title: "Fotos machen",
    card2_desc: "Klicke nach dem Shooting auf 'Weiter', um zur nächsten Seite zu gelangen. Wenn du ein einzelnes Foto wiederholen möchtest, klicke darauf und drücke auf 'Wiederholen'.",
    card3_title: "Rahmen wählen und Herunterladen",
    card3_desc: "Wähle eine Farbe oder einen Rahmen für das Foto aus und klicke auf 'Herunterladen', um es zu teilen.",
    feature_title: "Professionelle Fotobox für zu Hause – komplett kostenlos",
    feature_sub1: "Reibungslose Erfahrung",
    feature_sub2: "Keine Registrierung erforderlich",
    feature_sub3: "Keine Werbung",
    feature_sub4: "Kein Wasserzeichen",
    feature_layout_title: "Vielfältige Layouts und Rahmen",
    feature_layout_desc: "Werde kreativ mit einer großen Auswahl an Layouts und Rahmen, von klassisch bis modern, und mache deine Fotos einzigartiger denn je.",
    feature_filter_title: "Wunderschöne Fotobox-Filter",
    feature_filter_desc: "Speziell abgestimmte Farbfilter im Fotobox-Stil, die die Haut strahlen lassen und Farben kristallklar machen.",
    feature_share_title: "Mit einem Klick mit allen teilen",
    feature_share_desc: "Einfach herunterladen oder schnell per QR-Code teilen – verbreite Freude im Handumdrehen mit Freunden und Familie.",
    shoot_now: "Jetzt fotografieren"
  },
  gallery: {
    title: "Galerie",
    heading: "Deine Momente 💙",
    photo_count: "Fotos",
    secure: "100% Sicher",
    free: "Kostenlos",
    send_photo: "Schick uns deine Fotos!",
    description: "Die authentischsten Fotos, die von Benutzern gesendet wurden – jedes einzelne ein unvergesslicher Moment. Abgesehen von der QR-Code-Sharing-Funktion speichert die Website keines Ihrer Fotos, also seien Sie zu 100 % beruhigt! Sie können wählen, ob Sie es beim Herunterladen oder durch Klicken auf die Schaltfläche daneben an uns senden möchten!",
    loading_more: "Lade mehr...",
    no_photos: "Noch keine Fotos vorhanden"
  },
  guide_create: {
    title: "Anleitung zur Rahmenerstellung",
    subtitle: "So erstellen Sie Rahmen mit Canva",
    desc1: "Wir haben Basisrahmen für dich vorbereitet, damit du kreativ werden kannst! 🎨",
    desc2: "Die von dir erstellten Rahmen können mit der benutzerdefinierten Rahmenfunktion verwendet werden!",
    step1_title: "Wähle eine Canva-Rahmenvorlage",
    template4: "4-Foto-Vorlage (1x4)",
    template4_desc: "Für vertikales 4-Foto-Layout.",
    template6: "6-Foto-Vorlage (2x3)",
    template6_desc: "Für 6-Foto-Layout.",
    template2: "2-Foto-Vorlage (2x2)",
    template2_desc: "Für 2-Foto-Layout.",
    step2_note_title: "Wichtiger Hinweis:",
    step2_note_desc: "Behalte den farbigen Bereich im kleinen Rahmen (grau, blau oder das Quadrat für das Foto) in der Mitte als Hintergrund für die Entfernung bei.",
    step2_tip: "💡 Du kannst zuerst den Rahmen nur mit dem Hintergrund herunterladen, den Hintergrund entfernen und ihn dann wieder auf Canva hochladen, um Sticker hinzuzufügen (um eine unsaubere Entfernung bei sehr komplexen Stickern zu vermeiden)",
    step3_title: "Bild herunterladen",
    step3_desc: "Lade den neu erstellten Rahmen nach dem Designen auf dein Gerät herunter, um ihn für die Verwendung vorzubereiten!",
    step4_title: "Hintergrund mit Photopea entfernen",
    step4_desc: "🖼️ Anleitung zum Entfernen des Hintergrunds auf Photopea",
    step4_li1: "Gehe zu Photopea.com",
    step4_li2: "Ziehe die Bilddatei hinein oder drücke 'Strg + O', um das Bild zu öffnen, das du gerade von Canva heruntergeladen hast.",
    step4_li3: "Wähle das Zauberstab-Werkzeug aus.",
    step4_li4: "Klicke auf den farbigen Bereich in der Mitte, um ihn auszuwählen.",
    step4_li5: "Drücke die Entf-Taste auf deiner Tastatur.",
    step4_li6: "Gehe zu Datei > Exportieren als > PNG. Klicke auf Speichern.",
    step5_title: "Abschluss & Community",
    step5_desc1: "✨ Jetzt hast du eine transparente PNG-Datei! Gehe zurück zur Website, klicke auf die Schaltfläche \"Benutzerdefinierten Rahmen hochladen\" auf der Rahmenauswahlseite und lade ihn für den privaten Gebrauch hoch.",
    step5_desc2: "🔒 Die Website speichert keine Bilder, so dass du sie bedenkenlos verwenden kannst!!!",
    step5_community: "Lass uns gemeinsam die Community aufbauen",
    step5_community_desc1: "Wenn du einen wirklich schönen und zufriedenstellenden Rahmen erstellt hast und ihn mit anderen auf dieser Website teilen möchtest, zögere nicht, uns deine PNG-Datei über Instagram zu schicken.",
    step5_community_desc2: "💜 Dein Beitrag wird unsere Rahmengalerie bereichern. Vielen Dank! ❤️"
  },
  guide_use: {
    title: "Bedienungsanleitung",
    subtitle: "Mit nur 5 einfachen Schritten kannst du einzigartige Fotobox-Bilder erstellen und Erinnerungen mit Freunden festhalten!",
    step: "Schritt",
    step1_title: "Starte deine Reise",
    step1_desc: "Klicke auf der Startseite auf \"Fotoshooting starten\". Vergiss nicht, deinem Browser den Kamerazugriff zu erlauben! (Alle Bilder werden für maximale Privatsphäre nur lokal verarbeitet).",
    step2_title: "Wähle ein Layout",
    step2_desc: "Durchstöbere und wähle das Foto-Layout, das dir am besten gefällt. Viele süße Layouts warten auf dich.",
    step3_title: "Posiere & Fotografiere",
    step3_desc: "Wähle passende Farbfilter oder Effekte. Passe deinen Kamerawinkel an, nimm deine besten Posen ein und beginne mit dem Fotografieren! Klicke nach allen Aufnahmen auf \"Weiter\".",
    step4_title: "Dekoriere deinen Rahmen",
    step4_desc: "Hebe dein Foto hervor, indem du eine Hintergrundfarbe wählst, die zu deinem Stil passt, oder wähle direkt auffällige, verfügbare Rahmen aus unserer Galerie.",
    step5_title: "Speichern & Teilen",
    step5_desc: "Dein Meisterwerk ist fertig! Du kannst das hochauflösende Bild sofort herunterladen oder die Funktion \"QR Teilen\" nutzen, um es schnell an deine Freunde zu senden.",
    ready: "Bist du bereit?",
    create_frame_btn: "Erstelle deinen eigenen Rahmen",
    start_btn: "Jetzt mit dem Shooting beginnen",
    faq_title: "Häufig gestellte Fragen",
    q1: "Was ist KenT Photobooth?",
    a1: "KenT Photobooth ist eine Webanwendung, mit der Sie Fotobox-Fotos direkt in Ihrem Computer- oder Telefonbrowser aufnehmen können, ohne eine Software zu installieren.",
    q2: "Speichert die Website meine Fotos?",
    a2: "Ganz und gar nicht. Die gesamte Fotoverarbeitung findet direkt in Ihrem Browser statt (Client-side). Fotos werden nur vorübergehend auf dem Server gespeichert, wenn Sie aktiv die Funktion 'QR teilen' wählen, um Fotos auf Ihr Telefon herunterzuladen.",
    q3: "Ist das Teilen per QR sicher?",
    a3: "Sehr sicher. Sharing-Links laufen automatisch ab und alle Daten auf dem Server werden nach 1 Woche gelöscht. Niemand kann Ihre Fotos ohne Ihren spezifischen Link oder QR-Code sehen.",
    q4: "Kann ich meine eigenen Rahmen verwenden?",
    a4: "Ja! Im Bereich 'Rahmen erstellen' finden Sie Anleitungen zum Erstellen eigener Rahmen mit Canva und Photopea, die Sie dann für den privaten Gebrauch hochladen können.",
    q5: "Ist die Website kostenlos?",
    a5: "Die Website ist zu 100 % kostenlos. Sie können mich unterstützen (Spenden), indem Sie auf den Bereich 'Kontakt' klicken, um mir zu helfen, den Server zu warten!",
    steps_title: "Ausführungsschritte",
    still_need_help: "Benötigen Sie noch Hilfe?",
    help_desc: "Wenn Sie bei der Verwendung auf Probleme stoßen oder Ideen beisteuern möchten, zögern Sie nicht, uns eine Nachricht zu senden!",
    contact_now: "Jetzt kontaktieren"
  },
  contact: {
    donate_title: "☕ Spendier mir einen Kaffee!",
    donate_desc: "Hilf mir, motiviert zu bleiben, den Server zu warten und weitere neue Funktionen zu entwickeln! 💕",
    admin_badge: "Admin",
    contact_info: "Kontaktinformationen",
    contact_desc: "Ich habe diese Fotobox-Website als Geschenk für meine süße mhoa programmiert 🥰💕",
    fb_page1: "Facebook-Seite",
    fb_page2: "Facebook-Seite"
  },
  about: {
    welcome: "Willkommen bei KenT PhotoBooth",
    title1: "Halte die Momente fest",
    title2: "Auf deine eigene Weise",
    desc: "Wir bringen ein professionelles Fotobox-Erlebnis direkt in deinen Browser. Schnell, privat und völlig kostenlos.",
    team_title: "Entwicklungsteam",
    author_title: "Autor: Que Minh Thanh (Dev 2k8)",
    author_desc: "Derjenige, der den Grundstein gelegt und das gesamte KenT PhotoBooth-System aufgebaut hat. Mit einer Leidenschaft für Technologie und Kreativität hat KenT Software die Idee einer praktischen Online-Fotobox für alle verwirklicht.",
    designer_title: "Rahmendesigner: Que Minh Thanh, Que Mai Huong",
    designer_desc: "Das Team hinter den funkelnden und vielfältigen Rahmenvorlagen. Akribisch in jedem Detail, um sicherzustellen, dass jedes deiner Fotos zu etwas Besonderem wird und deine persönliche Note trägt.",
    journey_title: "Entwicklungsreise",
    m1_title: "Projektstart",
    m1_desc: "Die ersten Steine für die Idee einer digitalen Fotobox wurden gelegt. Das Projekt begann mit dem Wunsch, durch jeden Rahmen Freude zu bereiten.",
    m2_title: "Erste finale Version",
    m2_desc: "Nach fast 2 Monaten harter Entwicklung wurde die erste vollständige Version offiziell geboren und markierte einen wichtigen Meilenstein in der kreativen Reise.",
    m3_title: "Öffentlich online",
    m3_desc: "Das Projekt wurde offiziell online gestellt. Ursprünglich aus reinem HTML, CSS und JS aufgebaut und in den ersten 3 Wochen aktiv betrieben.",
    m4_title: "Restrukturierung & React",
    m4_desc: "Ein wichtiger Wendepunkt, als der gesamte Quellcode auf die moderne React-Plattform umgestellt wurde. Gleichzeitig wurde Facebook KenT Photobooth gegründet, um die Nutzer zu vernetzen.",
    m5_title: "Offizieller Relaunch",
    m5_desc: "Offizielle Rückkehr mit neuem Look, hervorragender Performance und stabilem Betrieb bis heute.",
    features_title1: "Maximale Sicherheit",
    features_desc1: "Ihre Daten sind streng geschützt und werden auf Ihrem eigenen Gerät verarbeitet. Fotos werden nur auf dem Server gespeichert, wenn Sie die QR-Sharing-Funktion nutzen.",
    features_title2: "Riesige Rahmenbibliothek",
    features_desc2: "Ständig aktualisiert mit den neuesten Trends: Y2K, Aesthetic, Vintage und mehr.",
    features_title3: "Völlig Kostenlos",
    features_desc3: "Erleben Sie alle Premium-Funktionen ohne Kosten. Ihre Freude ist unsere Motivation.",
    features_title4: "Sofortiges Teilen",
    features_desc4: "Erstellen Sie QR-Codes und teilen Sie Fotos in Sekundenschnelle mit Freunden. Praktisch und superschnell.",
    features_title5: "Nahtlose Erfahrung",
    features_desc5: "Optimierte Benutzeroberfläche, funktioniert reibungslos auf allen Geräten, vom Handy bis zum Desktop.",
    features_title6: "Kristallklare Qualität",
    features_desc6: "Fotos werden in hoher Auflösung exportiert, sodass jedes Detail Ihrer Erinnerungen lebendig und scharf bleibt.",
    cta_title: "Bereit für schöne Fotos?",
    cta_desc: "Tritt der KenT PhotoBooth-Benutzer-Community bei und beginne noch heute mit dem Erstellen.",
    cta_btn: "Fotoshooting starten",
    users: "1000+ Nutzer"
  },
  photo_layout: {
    title: "Wähle dein Lieblingslayout!",
    subtitle: "Wir werden in Zukunft weitere Rahmen hinzufügen. 🌸",
    photos: "Fotos",
    start_btn: "Shooting starten",
    alert_select: "Bitte wähle ein Layout aus, bevor du fortfährst.",
    layout_prefix: "Layout",
  },
  take_photo: {
    record_video_btn: "Video",
    settings_btn: "Einstellungen",
    layout_label: "Layout:",
    reselect_layout: "Layout neu wählen",
    confirm_reselect: "Bist du sicher, dass du das Layout neu wählen möchtest? Bereits aufgenommene Fotos gehen verloren.",
    upload_photos: "Fotos hochladen",
    camera: "Kamera",
    confirm_upload: "Bist du sicher, dass du in den Upload-Modus wechseln möchtest? Aufgenommene Fotos gehen verloren.",
    confirm_exit_video_mode: "Möchtest du den Modus wechseln, bevor die Aufnahme abgeschlossen ist? Aktuelle Fotos gehen verloren.",
    flash_toggle: "Blitz-Effekt umschalten",
    flip_camera: "Kamera spiegeln (Mirror)",
    alert_camera_off: "Bitte schalte zuerst die Kamera ein!",
    confirm_retake: "Bist du sicher, dass du Foto # wiederholen möchtest?",
    confirm_change: "Möchtest du dieses Foto ändern?",
    alert_need_photos: "Es werden {requiredPhotos} Fotos benötigt, um fortzufahren!",
    filter_normal: "Normal",
    filter_gray: "Grau",
    filter_sepia: "Sepia",
    filter_bright: "Hell",
    filter_contrast: "Scharf",
    filter_blur: "Unschärfe",
    slot: "Platz",
    support_off: "Hilfe aus",
    support_on: "Shooting-Hilfe",
    capturing: "Aufnahme...",
    processing: "Verarbeitung...",
    processing_subtitle: "Ihre Fotos werden verarbeitet...",
    manual_capture: "Manuell",
    retake_photo_btn: "Foto # wiederholen",
    auto_capture: "Auto",
    continue_btn: "Weiter",
    confirm_retake_all: "Bist du sicher, dass du alle wiederholen möchtest? Aufgenommene Fotos gehen verloren.",
    retake_all_btn: "Alle wiederholen",
    countdown_label: "⏱️ Countdown:",
    seconds: "Sek.",
    filter_title: "Filter",
    effect_title: "Effekte",
    effect_notice: "(Nach der Aufnahme sichtbar)",
    settings_title: "Kamera-Einstellungen",
    select_camera: "Kamera auswählen:",
    camera_label: "Kamera",
    switch_camera_tip: "Vorder-/Rückkamera wechseln",
    mirror_label: "Kamera spiegeln",
    sound_label: "Aufnahmeton aktivieren",
    flash_screen_label: "Blitz-Effekt aktivieren",
    live_gif_label: "Video mit Fotos aufnehmen (5 Sek.)",
    close_btn: "Schließen",
    edit_title: "Foto bearbeiten",
    cancel_btn: "Abbrechen",
    apply_btn: "Anwenden",
    crop_tip: "Sorgfältig zuschneiden!!!",
    support_modal_title: "Hilfsrahmen auswählen",
    support_modal_desc: "Virtueller Rahmen auf der Kamera zur Ausrichtung. Der echte Rahmen wird am Ende gewählt.",
    search_placeholder: "Rahmen suchen...",
    clear_support_btn: "Aktuellen Hilfsrahmen ausschalten"
  },
  result: {
    thanks: "Vielen Dank, dass du unsere Web-App benutzt!",
    confirm_retake: "Möchtest du es wiederholen?",
    upload_success: "Vielen Dank für das Teilen deines Fotos!",
    upload_error: "Fehler beim Hochladen des Fotos.",
    no_image_to_share: "Kein Bild zum Teilen gefunden.",
    error_load_frame: "Benutzerdefinierter Rahmen konnte nicht geladen werden!",
    error_load_img: "Rahmen konnte nicht geladen werden:",
    error_invalid_file: "Ungültige Datei! Bitte wähle ein PNG-Bild aus.",
    cancel_btn: "Abbrechen",
    photo_num: "Foto",
    scroll_tip: "Scrolle nach unten, um deinen Fotorahmen zu dekorieren",
    bg_color: "Hintergrund",
    photo_mode: "Fotomodus",
    photo_frame: "Fotorahmen",
    use_custom_frame: "Eigener Rahmen",
    search_frame_placeholder: "Rahmen suchen...",
    complete_btn: "Fertig",
    retake_btn: "Wiederholen",
    contribute_title: "Zur Bibliothek beitragen",
    contribute_question: "Möchtest du dein Foto in unserer Galerie teilen?",
    frame_upload_success: "Benutzerdefinierter Rahmen erfolgreich hochgeladen!",
    qr_success: "QR-Code erstellt!",
    qr_error: "QR-Code konnte nicht erstellt werden. Bitte versuche es erneut.",
    zoom_photo: "Foto zoomen",
    share_qr_label: "QR teilen",
    creating_qr: "Erstelle...",
    create_qr_btn: "QR erstellen",
    share_your_photo: "Teile dein Foto",
    share_via_qr: "Über QR teilen",
    generate_qr: "QR generieren",
    select_download_title: "Fotos zum Herunterladen auswählen",
    download_photo_title: "Foto herunterladen",
    save_all: "Streifen speichern",
    save_one: "Einzeln speichern",
    download_btn: "Herunterladen",
    video_processing: "Wird verarbeitet...",
    download_video_btn: "Video herunterladen",
    close_btn: "Schließen",
    your_photo_title: "Dein Foto",
    loading_photo: "Foto wird geladen...",
    one_photo: "1 Foto",
    two_photos: "2 Fotos",
    custom_frame_title: "Eigenen Rahmen hochladen",
    frame_uploaded: "Rahmen hochgeladen",
    drag_drop_tip: "Bild hierher ziehen & ablegen",
    or_click_tip: "oder klicken, um Datei auszuwählen",
    yes_create_qr: "Ja & QR erstellen",
    no_continue_qr: "Nein, nur QR erstellen",
    generating_qr: "QR-Code wird generiert",
    generating_qr_desc: "Wir generieren einen QR-Code, damit du dein Foto teilen kannst, bitte warte einen Moment!",
    your_qr_title: "Dein QR-Code",
    scan_qr_tip: "Scanne den QR-Code mit deiner Handykamera, um das Foto herunterzuladen!",
    or_copy_link: "Oder Link kopieren:",
    copied_link: "Link kopiert!",
    storage_notice: "Hinweis: Dieses Foto bleibt 1 Woche lang erhalten. Danach wird es automatisch gelöscht!",
    storage_note_title: "Hinweis",
    storage_note_part1: "Dieses Foto bleibt für",
    storage_note_duration: "1 Woche",
    storage_note_part2: "erhalten. Danach wird es automatisch gelöscht!",
    thanks_title: "Vielen Dank!",
    share_invite: "Bitte teile es mit allen!",
    frame_update_notice: "Neue Rahmen werden ständig aktualisiert ^^",
    contribute_question_alt: "Möchtest du dieses Foto zur öffentlichen Sammlung beisteuern?",
    yes_contribute: "Ja, beitragen",
    no_thanks: "Nein, danke",
    contribute_success: "Erfolgreich beigetragen!",
  },
  share_view: {
    not_found: "Foto existiert nicht oder ist abgelaufen",
    load_error: "Foto konnte nicht geladen werden. Bitte versuche es erneut.",
    loading_title: "Foto wird geladen...",
    loading_sub: "Foto wird vom Server abgerufen",
    error_title: "Foto nicht gefunden",
    home_btn: "Zurück zur Startseite",
    header_title: "Foto teilen",
    header_sub: "Geteilt von KenT Photobooth",
    one_photo: "1 Foto",
    two_photos: "2 Fotos",
    tooltip_not_ready: "2-Foto-Version nicht bereit",
    tooltip_ready: "Zeige 2 Fotos",
    tag_layout: "Layout:",
    tag_frame: "Hat Rahmen",
    tag_valid: "Gültig für 1 Woche",
    download_title: "Herunterladen",
    downloading: "Wird heruntergeladen...",
    download_btn: "Jetzt herunterladen",
    cta_text: "Möchtest du deine eigene Fotobox erstellen?",
    cta_btn: "Erstelle deine eigene",
    notice: "Hinweis:",
    notice_server: "Dieses Foto ist nur für 1 Woche verfügbar und wird automatisch gelöscht.",
    notice_local: "Dieser Link funktioniert nur, solange der Absender auf der Website ist. Bitte jetzt herunterladen!",
    tip: "Tipp: Speichere das Foto, um deine schönen Erinnerungen zu bewahren!",
    created_by: "Erstellt von",
    preparing: "Bereite Foto vor...",
    preparing_sub: "Optimiere das PNG-Format für dich.",
    select_download_title: "Fotos zum Herunterladen auswählen",
    photo_num: "Foto",
    cancel_btn: "Abbrechen",
    download_btn: "Herunterladen",
    custom_frame_title: "Eigenen Rahmen hochladen",
    frame_uploaded: "Rahmen hochgeladen",
    drag_drop_tip: "Bild hierher ziehen & ablegen",
    or_click_tip: "oder klicken, um Datei auszuwählen",
    contribute_title: "Zur Galerie beitragen",
    contribute_question: "Möchtest du dein Foto in unserer Galerie teilen?",
    yes_create_qr: "Ja & QR erstellen",
    no_continue_qr: "Nein, nur QR erstellen",
    generating_qr: "QR-Code wird generiert",
    generating_qr_desc: "Wir generieren einen QR-Code, damit du dein Foto teilen kannst, bitte warte einen Moment!",
    your_qr_title: "Dein QR-Code",
    scan_qr_tip: "Scanne den QR-Code mit deiner Handykamera, um das Foto herunterzuladen!",
    or_copy_link: "Oder Link kopieren:",
    copied_link: "Link kopiert!",
    storage_notice: "Hinweis: Dieses Foto bleibt 1 Woche lang erhalten. Danach wird es automatisch gelöscht!",
    close_btn: "Schließen",
    thanks_title: "Vielen Dank!",
    share_invite: "Bitte teile es mit allen!",
    frame_update_notice: "Neue Rahmen werden ständig aktualisiert ^^",
    contribute_question_alt: "Möchtest du dieses Foto zur öffentlichen Sammlung beisteuern?",
    yes_contribute: "Ja, beitragen",
    no_thanks: "Nein, danke",
    contribute_success: "Erfolgreich beigetragen!",
    your_photo_title: "Dein Foto",
    loading_photo: "Foto wird geladen...",
    one_photo: "1 Foto",
    two_photos: "2 Fotos",
    download_photo_title: "Foto herunterladen",
    save_all: "Streifen speichern",
    save_one: "Einzeln speichern",
    creating_qr: "Erstelle...",
    create_qr_btn: "QR erstellen",
    share_your_photo: "Teile dein Foto",
    share_via_qr: "Über QR teilen"
  },
  welcome_modal: {
    title: "Willkommen!",
    timer_title: "Timer wählen",
    timer_body: "Du kannst die Countdown-Zeit für jede Aufnahme wählen!",
    session_title: "Aufeinanderfolgende Aufnahmen",
    session_body: "In dieser Sitzung werden mehrere Fotos hintereinander gemacht — zeig deine besten Posen! 🌟",
    privacy_title: "Datenschutzhinweis",
    privacy_body: "Sofern du die Sharing-Funktion nicht verwendest, speichert die Website keine Fotos von dir.",
    start_btn: "START"
  },
  footer: {
    description: "Photobooth ist ein Ort, um unvergessliche Momente mit hoher Bildqualität, freundlicher Benutzeroberfläche und vielen kreativen Effekten für alle Altersgruppen festzuhalten.",
    contact: "Kontakt",
    total_visits: "Besucher gesamt:"
  }
};

export default de;
